export default "__VITE_ASSET__CIiFFpdf__"